module.exports = __webpack_public_path__ + "static/media/musiostore_home_mo.f015833e.png";